// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-Button__wrapper","iconInside":"c-Button__iconInside","iconOutside":"c-Button__iconOutside","iconRight":"c-Button__iconRight","right":"c-Button__right","inner":"c-Button__inner","button":"c-Button__button","outline":"c-Button__outline","center":"c-Button__center","big":"c-Button__big","low":"c-Button__low","clear":"c-Button__clear","short":"c-Button__short","long":"c-Button__long","medium":"c-Button__medium","left":"c-Button__left","primary":"c-Button__primary","ripple":"c-Button__ripple","small":"c-Button__small","disabled":"c-Button__disabled"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/Button/Button.scss
// module id = 804
// module chunks = 0